import RemoteReactApp from './remote-react-app';

export default RemoteReactApp;
